import { getSelectedCalendarsFlatList } from 'owa-calendar-module-selected-calendars-user-config';
import { getUpNextEventLockId } from 'owa-calendar-surface-events-lock-store';
import { initializeUpNextEventLoader, isUpNextScenarioInitialized } from 'owa-upnext-event-loader';

export function initializeEventsNow() {
    if (!isUpNextScenarioInitialized(getUpNextEventLockId())) {
        initializeUpNextEventLoader(getSelectedCalendarsFlatList(), getUpNextEventLockId());
    }
}
